import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UsersBoard } from './UsersBoard/UsersBoard';
import { UserPageInfo } from './UserPageInfo/UserPageInfo';
import { getParams } from '~/utils/getPaginate';
import { UserTabs } from '~/utils/types/dashboard';

const Users = (): JSX.Element => {
  const { value } = getParams(UserTabs.ACTIVE_TRIP)
  const [userTripStatus, setTripStatus] = useState(value);
  const { t } = useTranslation();


  return (
    <Page heading={<Heading text={t('all_employees')} />}>
      <UserPageInfo
        userTripStatus={userTripStatus}
        setTripStatus={setTripStatus}
      />
      <UsersBoard userTripStatus={userTripStatus} />
    </Page>
  );
};

export default Users;
